module.exports = __webpack_public_path__ + "media/images/matte-bedeb17926adadd7cd91005d35005c01.png";